import { usePersistentStore } from "@/store";

export default [
  {
    path: "/",
    redirect: () => {
      const store = usePersistentStore();
      return { path: store.app.states.searchView };
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/LoginView.vue"),
    meta: {
      title: "Login",
      public: true,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    meta: {
      public: true,
    },
    component: () => import("@/views/ForgotPasswordView.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    meta: {
      public: true,
    },
    component: () => import("@/views/ResetPasswordView.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/RegisterView.vue"),
    meta: {
      title: "Register",
      public: true,
    },
    beforeEnter: async (to, _from, next) => {
      next(to.query.token ? undefined : "/login");
    },
  },
  { path: "/:pathMatch(.*)", component: () => import("@/views/NotFoundView.vue") },
];
